import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11" {...props}>
    <path
      fill="currentColor"
      d="M1.116 1.116a1.25 1.25 0 0 1 1.768 0L5.5 3.733l2.616-2.617a1.25 1.25 0 0 1 1.768 1.768L7.267 5.5l2.617 2.616a1.25 1.25 0 0 1 .091 1.666l-.091.102a1.25 1.25 0 0 1-1.768 0L5.5 7.267 2.884 9.884a1.25 1.25 0 0 1-1.768-1.768L3.733 5.5 1.116 2.884a1.25 1.25 0 0 1-.091-1.666Z"
    />
  </svg>
);
export const CloseToggleIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
